import { Box, MenuItem, Select, TextField, Typography } from "@mui/material"
import { Back } from "../../../components/public/Button"
import { useState } from "react";
import { MapNewSubscription } from "../../../components/Table/mapping-function/TableMapping";
import { PackageTable } from "../../../components/Table/component/PackageTable";

export const AdminNewSubscription = () => {
    const [userFilter, setUserFilter] = useState('');
    const [subscriptionName, setSubscriptionName] = useState('');
    const [billTypeFilter, setBillTypeFilter] = useState('');
    const [subscriptionCost, setSubscriptionCost] = useState('');
    const [page, setPage] = useState(1);
    const [rowsPerPage] = useState(10);
    const [randomNum, setRandomNum] = useState(Math.round(Math.random() * (5000 - 5 + 1)) + 5);
    const fieldWidth = '24%';
    const spacing = 'calc(100% - (4 * 23%)) / 3';
    const fn = MapNewSubscription(new Array(randomNum).fill(4))
    const tbl = fn()
    let prop = {
        title: 'Activity Table',
        tableStyle: { OutBox: { borderRadius: "8px", borderBottomLeftRadius: 0, borderBottomRightRadius: 0, }, },
        filteredData: tbl,
        // filteredData: tab === '0' ? tableData : tableData,
        // filteredData: tab === '0' ? tableRoleFeature : [],
        rowsPerPage,
        page,
        setPage,
        borderBoxStyle: { px: 0 },
        goto: true,
    }
    return (
        <Box>
            <Back prop={{ txt: 'Custom Subscription' }} />
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Box sx={{ width: fieldWidth }}>
                    <Typography sx={{ color: "#000000", mb: '5px' }}>
                        User
                    </Typography>
                    <Select
                        displayEmpty
                        size='small'
                        value={userFilter}
                        onChange={(e) => setUserFilter(e.target.value)}
                        sx={{
                            width: "100%",
                            height: "40px",
                            '& .MuiOutlinedInput-notchedOutline': {
                                borderColor: "#D0D5DD",
                            },
                            '&:hover .MuiOutlinedInput-notchedOutline': {
                                borderColor: "#D0D5DD",
                            },
                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                borderColor: "#D0D5DD",
                            },
                            '& .MuiSelect-select': {
                                display: 'flex',
                                alignItems: 'center',
                            },
                        }}
                    >
                        <MenuItem sx={{ display: 'none', color: '#474747' }} value="" disabled>
                            Enter or select user
                        </MenuItem>
                        <MenuItem value='User1@gmail.com' sx={{ fontSize: '12px', fontWeight: '400', color: '#797F8F' }}>User1@gmail.com</MenuItem>
                        <MenuItem value='User2@gmail.com' sx={{ fontSize: '12px', fontWeight: '400', color: '#797F8F' }}>User2@gmail.com</MenuItem>
                    </Select>
                </Box>
                <Box sx={{ width: fieldWidth }}>
                    <Typography sx={{ color: "#000000", mb: '5px' }}>
                        Subscription Name
                    </Typography>
                    <TextField
                        placeholder="Enter Subscription Name"
                        value={subscriptionName}
                        onChange={(event) => setSubscriptionName(event.target.value)}
                        InputProps={{ sx: { height: "40px", width: "100%", borderColor: "#727272" } }}
                        sx={{ color: "#727272", width: "100%", }}
                    />
                </Box>
                <Box sx={{ width: fieldWidth }}>
                    <Typography sx={{ color: "#000000", mb: '5px' }}>
                        Bill Type
                    </Typography>
                    <Select
                        displayEmpty
                        size='small'
                        value={billTypeFilter}
                        onChange={(e) => setBillTypeFilter(e.target.value)}
                        sx={{
                            width: "100%",
                            height: "40px",
                            color: '#474747',
                            '& .MuiOutlinedInput-notchedOutline': {
                                borderColor: "#D0D5DD",
                            },
                            '&:hover .MuiOutlinedInput-notchedOutline': {
                                borderColor: "#D0D5DD",
                            },
                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                borderColor: "#D0D5DD",
                            },
                            '& .MuiSelect-select': {
                                display: 'flex',
                                alignItems: 'center',
                            },
                        }}
                    >
                        <MenuItem sx={{ display: 'none', color: '#474747' }} value="" disabled>
                            Select bill type
                        </MenuItem>
                        <MenuItem value='Monthly' sx={{ fontSize: '12px', fontWeight: '400', color: '#797F8F' }}>Monthly</MenuItem>
                        <MenuItem value='Yearly' sx={{ fontSize: '12px', fontWeight: '400', color: '#797F8F' }}>Yearly</MenuItem>
                    </Select>
                </Box>
                <Box sx={{ width: fieldWidth }}>
                    <Typography sx={{ color: "#000000", mb: '5px' }}>
                        Subscription Cost
                    </Typography>
                    <TextField
                        placeholder="Enter Subscription cost"
                        value={subscriptionCost}
                        onChange={(event) => setSubscriptionCost(event.target.value)}
                        InputProps={{ sx: { height: "40px", width: "100%", borderColor: "#727272" } }}
                        sx={{ color: "#727272", width: "100%", }}
                    />
                </Box>
            </Box>
            <PackageTable prop={prop}/>
        </Box>
    )
}